(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["booglow"] && !Shopify.designMode) return;
  try {
    function initBooGlow(){document.querySelectorAll('[data-booglow]').forEach(page=>{
if(page.dataset.ready)return;page.dataset.ready='true';
const unitVariants=JSON.parse(page.querySelector('[data-bg-unit-variants]').textContent);const offers=[3495,4995,6495,7995].map((price,i)=>({count:i+1,price,shipping:i===0?595:0,available:unitVariants.some(v=>v.available)}));let selected=1;let busy=false;
const fmt=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n/100);
const colors=['Orange','Blue','Green','Purple'];const chosen=['Orange','Blue','Green','Purple'];
const renderColors=count=>{const target=page.querySelector('[data-bg-colors]');target.replaceChildren();for(let i=0;i<count;i++){const label=document.createElement('label');label.textContent='Bag '+(i+1);const select=document.createElement('select');select.name='properties[Bag '+(i+1)+' color]';select.setAttribute('aria-label','Bag '+(i+1)+' color');colors.forEach(c=>{const option=document.createElement('option');option.value=c;option.textContent=c;option.disabled=!unitVariants.some(v=>v.color===c&&v.available);option.selected=c===chosen[i];select.append(option);});select.addEventListener('change',()=>chosen[i]=select.value);label.append(select);target.append(label);}};

const refresh=()=>{const o=offers[selected],total=o.price+o.shipping,ref=o.count*4495,saved=ref-o.price;
page.querySelector('[data-bg-subtotal]').textContent=fmt(o.price);page.querySelector('[data-bg-shipping]').textContent=o.shipping?fmt(o.shipping):'FREE';page.querySelector('[data-bg-total]').textContent=fmt(total);
page.querySelector('[data-bg-reference]').textContent=fmt(ref);page.querySelector('[data-bg-reference]').hidden=!saved;
page.querySelector('[data-bg-saved]').textContent=saved?'Total savings: '+fmt(saved)+' ('+Math.round(saved/ref*100)+'%) on bags':'';
page.querySelector('[data-bg-sticky]').textContent=o.count+' '+(o.count===1?'bag':'bags')+' · '+fmt(total);
page.querySelector('[data-bg-sticky-shipping]').textContent=o.shipping?'Includes $5.95 shipping · Before tax':'Free shipping · Before tax';
page.querySelector('[data-bg-choice]').textContent=o.count===1?'Your solo candy run':'Your '+o.count+'-bag haul';
renderColors(o.count);page.querySelectorAll('[data-bg-add]').forEach(b=>{b.disabled=busy||!o.available;b.textContent=o.available?(busy?'Adding…':'Add '+o.count+(o.count===1?' bag':' bags')+' to cart'):'Sold out';});};
page.querySelectorAll('[name="bg-pack"]').forEach((r,i)=>r.addEventListener('change',()=>{selected=i;refresh();}));
page.querySelectorAll('[data-bg-add]').forEach(b=>b.addEventListener('click',async()=>{if(busy)return;const o=offers[selected];if(!o.available)return;const quantities=new Map();for(const color of chosen.slice(0,o.count)){const variant=unitVariants.find(v=>v.color===color&&v.available);if(!variant)return;quantities.set(variant.id,(quantities.get(variant.id)||0)+1);}const items=[...quantities].map(([id,quantity])=>({id,quantity}));busy=true;refresh();const error=page.querySelector('.bg-cart-error');error.hidden=true;try{const {addHauntedItems}=await import(page.dataset.cartModule);await addHauntedItems(items,page);}catch(e){error.textContent=e.message||'Unable to add your bags. Please try again.';error.hidden=false;}finally{busy=false;refresh();}}));
const track=page.querySelector('.bg-track'),thumbs=[...page.querySelectorAll('[data-bg-photo]')];let photo=0;
const sync=()=>{photo=Math.max(0,Math.min(thumbs.length-1,Math.round(track.scrollLeft/track.clientWidth)));page.querySelector('[data-bg-counter]').textContent=(photo+1)+' / '+thumbs.length;thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===photo)));page.querySelector('[data-bg-prev]').disabled=photo===0;page.querySelector('[data-bg-next]').disabled=photo===thumbs.length-1;};
const show=i=>track.scrollTo({left:Math.max(0,Math.min(thumbs.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));page.querySelector('[data-bg-prev]').addEventListener('click',()=>show(photo-1));page.querySelector('[data-bg-next]').addEventListener('click',()=>show(photo+1));track.addEventListener('scroll',sync,{passive:true});track.addEventListener('keydown',e=>{if(['ArrowRight','ArrowLeft'].includes(e.key)){e.preventDefault();show(photo+(e.key==='ArrowRight'?1:-1));}});sync();refresh();
});}initBooGlow();document.addEventListener('shopify:section:load',initBooGlow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harvest-ember"] && !Shopify.designMode) return;
  try {
    
function initHarvestEmber(scope=document){
  scope.querySelectorAll('[data-ember]').forEach(page=>{
    if(page.dataset.initialized)return;
    page.dataset.initialized='true';
    const track=page.querySelector('.he-gallery-track');
    const thumbs=[...page.querySelectorAll('[data-gallery-index]')];
    let photo=0;
    const showPhoto=i=>{photo=Math.max(0,Math.min(thumbs.length-1,i));track.scrollTo({left:photo*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
    const syncPhoto=()=>{photo=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===photo)));page.querySelector('[data-gallery-status]').textContent=(photo+1)+' / '+thumbs.length;page.querySelector('[data-gallery-prev]').disabled=photo===0;page.querySelector('[data-gallery-next]').disabled=photo===thumbs.length-1;};
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>showPhoto(i)));
    page.querySelector('[data-gallery-prev]').addEventListener('click',()=>showPhoto(photo-1));
    page.querySelector('[data-gallery-next]').addEventListener('click',()=>showPhoto(photo+1));
    track.addEventListener('scroll',syncPhoto,{passive:true});
    track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();showPhoto(photo+(e.key==='ArrowRight'?1:-1));}});
    syncPhoto();
    const config=JSON.parse(page.querySelector('[data-ember-config]').textContent);
    const variants=config.variants;
    const money=new Intl.NumberFormat('en-US',{style:'currency',currency:page.dataset.currency});
    const fmt=cents=>money.format(cents/100);
    const pct=v=>((v.compare-v.price)/v.compare*100).toFixed(1).replace(/\.0$/,'');
    const form=page.querySelector('.he-form');
    const quantity=form.elements.quantity;
    const dialog=page.querySelector('dialog');
    const cart=new Map();
    let index=0;
    let busy=false;
    const escapedId=new URLSearchParams(location.search).get('variant');
    const requested=variants.findIndex(v=>String(v.id)===escapedId);
    if(requested>=0){index=requested;page.querySelectorAll('[name="ember-pack"]')[index].checked=true;}
    const amount=()=>Math.min(99,Math.max(1,Math.floor(Number(quantity.value)||1)));
    const refresh=()=>{
      const v=variants[index];
      if(!v)return;
      form.elements.id.value=v.id;
      page.querySelector('[data-total]').textContent=fmt(v.price*amount());
      const compareTotal=page.querySelector('[data-total-compare]');
      const savingsTotal=page.querySelector('[data-total-saving]');
      compareTotal.hidden=savingsTotal.hidden=!(v.compare>v.price);
      compareTotal.textContent=fmt(v.compare*amount());
      compareTotal.setAttribute('aria-label','Compare-at total '+fmt(v.compare*amount()));
      savingsTotal.textContent=v.compare>v.price?'You save '+fmt((v.compare-v.price)*amount())+' ('+pct(v)+'%)':'';
      page.querySelector('[data-sticky-pack]').textContent=v.title+' × '+amount();
      page.querySelector('[data-sticky-total]').textContent=fmt(v.price*amount())+(config.demo?' · Preview':'');
      page.querySelectorAll('.he-add,[data-sticky-add]').forEach(b=>{b.disabled=busy||!v.available;});
      if(!config.demo){page.querySelector('.he-add').firstChild.textContent=v.available?config.strings.add:config.strings.unavailable;}
    };
    variants.forEach((v,i)=>{
      const el=page.querySelector('[data-pack-price="'+i+'"]');
      if(!el)return;
      el.replaceChildren();
      if(v.compare>v.price){
        const was=document.createElement('del');was.className='he-was';was.textContent=fmt(v.compare);was.setAttribute('aria-label','Compare-at price '+fmt(v.compare));el.append(was);
      }
      const now=document.createElement('b');now.textContent=fmt(v.price);el.append(now);
      if(v.compare>v.price){const saved=document.createElement('span');saved.className='he-save';saved.textContent='Save '+fmt(v.compare-v.price)+' · '+pct(v)+'%';el.append(saved);}
      const small=document.createElement('small');small.textContent=fmt(v.price/v.count)+' '+config.strings.per;el.append(small);
      page.querySelector('[data-table-price="'+i+'"]').textContent=fmt(v.price);
      page.querySelector('[data-table-unit="'+i+'"]').textContent=fmt(v.price/v.count);
      page.querySelectorAll('[name="ember-pack"]')[i].disabled=!v.available;
    });
    const renderCart=()=>{
      const lines=page.querySelector('[data-cart-lines]');lines.replaceChildren();let subtotal=0;
      if(!cart.size)lines.textContent=config.strings.empty;
      for(const [id,item] of cart){
        subtotal+=item.price*item.quantity;
        const row=document.createElement('div');row.className='he-cart-line';
        const info=document.createElement('div');const name=document.createElement('strong');name.textContent='Harvest Ember · '+item.title;info.append(name,document.createTextNode(item.quantity+' × '+fmt(item.price)));
        const end=document.createElement('div');const total=document.createElement('strong');total.textContent=fmt(item.price*item.quantity);
        const remove=document.createElement('button');remove.type='button';remove.textContent=config.strings.remove;remove.setAttribute('aria-label',config.strings.remove+' '+item.title);remove.addEventListener('click',()=>{cart.delete(id);renderCart();});end.append(total,remove);row.append(info,end);lines.append(row);
      }
      page.querySelector('[data-cart-total]').textContent=fmt(subtotal);
      page.querySelector('[data-checkout]').disabled=!cart.size;
      page.querySelector('[data-checkout-note]').hidden=true;
    };
    page.querySelectorAll('[name="ember-pack"]').forEach(input=>input.addEventListener('change',()=>{index=Number(input.value);refresh();if(!config.demo){const url=new URL(location.href);url.searchParams.set('variant',variants[index].id);history.replaceState({},'',url);}}));
    quantity.addEventListener('input',refresh);
    quantity.addEventListener('change',()=>{quantity.value=amount();refresh();});
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(busy||!form.reportValidity())return;const v=variants[index];if(!v.available)return;
      quantity.value=amount();refresh();
      if(config.demo){const previous=cart.get(v.id);cart.set(v.id,{...v,quantity:(previous?.quantity||0)+amount()});renderCart();dialog.showModal();return;}
      busy=true;refresh();page.querySelector('.he-error').textContent='';
      try{const {addHauntedItems}=await import(page.dataset.cartModule);await addHauntedItems([{id:v.id,quantity:amount()}],page);}
      catch{page.querySelector('.he-error').textContent=config.strings.error;}
      finally{busy=false;refresh();}
    });
    page.querySelector('[data-sticky-add]').addEventListener('click',()=>form.requestSubmit());
    page.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
    page.querySelector('[data-clear]').addEventListener('click',()=>{cart.clear();renderCart();});
    page.querySelector('[data-checkout]').addEventListener('click',()=>{page.querySelector('[data-checkout-note]').hidden=false;});
    refresh();
  });
}
initHarvestEmber();
document.addEventListener('shopify:section:load',()=>initHarvestEmber());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
